export const SALES_ORDER_SHIP_WINDOW_MONTHS = 3;

const NZ = 'Pacific/Auckland';

export function nzCalendarDate(at: Date = new Date()): Date {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: NZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(at);
  const year = Number(parts.find((p) => p.type === 'year')!.value);
  const month = Number(parts.find((p) => p.type === 'month')!.value);
  const day = Number(parts.find((p) => p.type === 'day')!.value);
  return new Date(year, month - 1, day);
}

function addMonths(date: Date, months: number): Date {
  const day = date.getDate();
  const probe = new Date(date.getFullYear(), date.getMonth() + months, 1);
  const last = new Date(probe.getFullYear(), probe.getMonth() + 1, 0).getDate();
  return new Date(probe.getFullYear(), probe.getMonth(), Math.min(day, last));
}

export function salesOrderShipWindow(at: Date = new Date()): {
  minDate: Date;
  maxDate: Date;
} {
  const today = nzCalendarDate(at);
  return {
    minDate: addMonths(today, -SALES_ORDER_SHIP_WINDOW_MONTHS),
    maxDate: addMonths(today, SALES_ORDER_SHIP_WINDOW_MONTHS),
  };
}

export function isSalesOrderShipDateInWindow(
  date: Date,
  at: Date = new Date(),
): boolean {
  const day = nzCalendarDate(date).getTime();
  const { minDate, maxDate } = salesOrderShipWindow(at);
  return day >= minDate.getTime() && day <= maxDate.getTime();
}
